/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {getHalfMadeProductList} from "@/api/HalfMadeProduct"

export default {
  addHalfMadeProduct({ commit }, halfMadeProduct) {
    return new Promise((resolve, reject) => {
      commit('ADD_HALF_MADE_PRODUCT', halfMadeProduct)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsHalfMadeProduct({ commit },payload) {
    return new Promise((resolve, reject) => {
      getHalfMadeProductList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_HALF_MADE_PRODUCT', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateHalfMadeProduct({ commit }, halfMadeProduct) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_HALF_MADE_PRODUCT', halfMadeProduct)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeHalfMadeProduct({ commit }, halfMadeProductId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_HALF_MADE_PRODUCT', halfMadeProductId)
          resolve();
    })
  },
};